import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import "./uploaded.scss";
import qs from "query-string";
import { getValue } from "@utils/lodash";
import { adminGetAuditList, getManageAuditScoreFilter } from "@services/audit.service";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
// import DatePicker from "react-date-picker";
import { formatText } from "@_common/text-helpers";
// import { adminGetOrganization } from "@services/client-list.service";
// import InputField from "@_common/InputRuleFeild";
import NoAccessPage from "@components/common/NoAccess";
import { toast } from "react-toastify";
import CalenderDropdown from "@_common/CalenderDropdown";
import { convertCurrentDate, convertCurrentDateWithTime } from "@_common/date-helpers";
import InputField from "@_common/InputRuleFeild";
import { QueryRequestHelper } from "@_common/query-request-helper";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import MenuAuditSvgComponent from "../../../assets/svg-components/left-menu/menuadit";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";


export default function Uploaded(props: any) {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [info, setInfo] = useState({});
  const [filteredAccount, setFilteredAccount] = useState([]);
  const [pageFilter, setPageFilter] = useState({
    group: "",
  });

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      setSelectedClient(
        getValue(localStorage, `client`, "")
          ? getValue(localStorage, `client`, "")
          : ""
      );
      getData();
      setDate(new Date());
      getFilterAccount("","");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      setSelectedClient(
        getValue(localStorage, `client`, "")
          ? getValue(localStorage, `client`, "")
          : ""
      );
      getData();
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      if (params.group_id) {
        setPageFilter({
          ...pageFilter,
          group: getValue(params,`group_id`,""),
        });
      }

      if (params.group_id) {
        getFilterAccount(params.group_id, "");
      } else {
        getFilterAccount("", "");
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
        group_id: params.group_id,
      // audit_type: getValue(params, `type`, ""),
      // domain_name: client,
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await adminGetAuditList(queryRequest);
      if (resp) {
        // setLocations(getValue(resp, `data.vendors_checkpoint`, []));
        setLocations(
					getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
						...item,
						// total_audit: {getValue(item, `pending_audit`, '')} / {getValue(item, `still_with_vendor`, '')} / {getValue(item, `audit_complete_vendor`, '')},
            total_audit: `${getValue(item, `pending_audit`, '')} / ${getValue(item, `still_with_vendor`, '')} / ${getValue(item, `audit_complete_vendor`, '')}`,
            // score_count: getValue(item, `score`, '--'),
            score_count: `${getValue(item, 'score', '') ? `${getValue(item, 'score', '')}%` : '- -'}
            `,
					}))
				);
        setInfo(getValue(resp, `data.releaseInfo`, {}));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [searchLoading, setSearchLoading] = useState(false);
  const getFilterAccount = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    
    let payload: any = {
      month: params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM"),
      year: params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY"),
      group_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
      type: "GROUP",
      // vendor_id: mainParams.id,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredAccount(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            value: getValue(item, `group_name`, ""),
            label: getValue(item, `group_name`, ""),
          }))
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleTriggerAccount = async (value: string) => {
    if (!value) {
      setPageFilter({
        ...pageFilter,
        group: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.group_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setPageFilter({
        ...pageFilter,
        group: value,
      });
      getFilterAccount("", value);
    }
  };

  const handleChangeFilter = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        d_page_no: 1,
      };
      setPageFilter({
        ...pageFilter,
        [name]: value,
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        d_page_no: 1,
      };
      setPageFilter({
        ...pageFilter,
        [name]: "",
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
	const getTableState = (value: object) => {
		let selectedIndexList = Object.keys(
			getValue(value, `selectedRowIds`, {})
		).map((item) => parseInt(item));
		let selectedIds =
			locations.length > 0
				? locations.filter((_item: object, index: number) =>
						selectedIndexList.includes(index)
				  )
				: [];
		if (selectedIds.length > 0) {
			setSelectedIDs(
				selectedIds.map((item: object) => getValue(item, `id`, ""))
			);
		} else {
			setSelectedIDs([]);
		}
	};


  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.page_no = page_no;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    // if (e.target.value) {
    //   const urlSearchParams = new URLSearchParams(window.location.search);
    //   const params = Object.fromEntries(urlSearchParams.entries());
    //   setSearchInput(e.target.value);
    //   params.search_text = e.target.value;
    //   let queryRequest = qs.stringify(params);
    //   navigate(`${window.location.pathname}?${queryRequest}`);
    //   if (!e.target.value) {
    //     getData();
    //   }
    // } else {
    //   toggleSearchClose();
    // }
    const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		setSearchInput(e.target.value);

		let payload: any = {
			...params,
			page_no:1,
			search_text: e.target.value,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                             */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/audit/details/${getValue(bodyObj, `vendor_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/uploaded/${getValue(bodyObj, `vendor_name`, "")}?${mainQueryRequest}`
    );
  };

  // const urlParamsFun = () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let request = QueryRequestHelper({ ...params });
  //   return request;
  // };
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    delete params["search_text"];
    let request = QueryRequestHelper({ ...params });
    return request;
  };
  

  const mainQueryRequest = useMemo(() => urlParamsFun(), [
    window.location.href,
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const status = ["green-color", "blue-color", "black-color"];
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  /* -------------------------------------------------------------------------- */
  /*                             Client Setup                                   */
  /* -------------------------------------------------------------------------- */

  const [clientList, setClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const handleSelectClient = (e: string) => {
    localStorage.setItem("client", e);
    setSelectedClient(e);
    getData();
  };
  // const getClientList = async () => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());

  // 	let payload: any = {
  // 		page_no: params.page_no ? parseInt(params.page_no) : 1,
  // 		page_size: 100,
  // 		status: 'active',
  // 		sort_by: params.sort_by,
  // 	};
  // 	// removing null values
  // 	Object.keys(payload).forEach((key) => {
  // 		if (!payload[key] || payload[key] === undefined) {
  // 			delete payload[key];
  // 		}
  // 	});
  // 	let queryRequest = qs.stringify(payload);

  // 	try {
  // 		let resp = await adminGetOrganization(queryRequest);
  // 		if (resp) {
  // 			let list = getValue(resp, `data.organisations`, []).map(
  // 				(item: object) => ({
  // 					// ...item,
  // 					value: getValue(item, `domain_name`, ''),
  // 					label: getValue(item, `organisation_name`, ''),
  // 					organisation_name: getValue(item, `organisation_name`, ''),
  // 					id: getValue(item, `id`, ''),
  // 				})
  // 			);
  // 			setClientList(list);
  // 			if (getValue(list, `length`, 0) > 0) {
  // 				if (getValue(localStorage, `client`, '')) {
  // 					getData(getValue(localStorage, `client`, ''));
  // 				} else {
  // 					getData(getValue(list, `[${0}].value`, ''));
  // 					localStorage.setItem('client', getValue(list, `[${0}].value`, ''));
  // 					setSelectedClient(getValue(list, `[${0}].value`, ''));
  // 				}
  // 			} else {
  // 				getData('');
  // 			}
  // 		}
  // 	} catch (error) {}
  // };

  const filters = [
    {
      value: "UPLOADED",
      label: "Uploaded",
    },
    { value: "NOT_UPLOADED", label: "Not Uploaded" },
    { value: "COMPLETED", label: "Completed" },
  ];
  const handleNavigateFilter = (type: string) => {
    let payload: any = {
      ...params,
      page_no: 1,
      status: type,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const [selectedId, setSelectedId] = useState("");
	const rowClick = (obj: object) => {
    console.log(getValue(obj, `original`, []), "rowobj")
    handleNavigate(getValue(obj, `original`, []))
  };

	const getTrProps = (rowInfo:any) => {
		if (getValue(rowInfo,`id`,'')) {
		  return {
			style: {
			}
		  }
		}
		return {};
	  }

	const columns = React.useMemo(
		() => [
			{
				Header: "Vendor Name",
				accessor: "vendor_name",
				width: 400,
			},
			{
				Header: "Score",
				accessor: "score_count",
				width: 250,
			},
			{
				// Header: "Total Audit",
        Header: (
          <>
            Total Audit
            <br />
            <span style={{ fontSize: "smaller", fontWeight: "normal" }}>
              (Pending Audit / Still With Vendor / Audit Complete)
            </span>
          </>
        ),      
				accessor: "total_audit",
				width: 250,
			},
		],
		[]
	);

  const [complianceStatusList] = useState([
    // { value: "NOT_SUBMITTED", label: "Not Submitted" },
    { value: "PENDING_AUDIT", label: "Pending Audit" },
    // { value: "COMPLIED", label: "Complied" },
    // { value: "NON_COMPLIED", label: "Non Complied" },
    // { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    // { value: "NOT_APPLICABLE", label: "Not Applicable" },
    // { value: "SEND_BACK_TO_VENDOR", label: "Send Back to Vendor" },
  ]);


  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_vendor_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            {/* <div>
              <InputField
                inputType="INPUT_REACT_SELECT_MODAL"
                placeholder="Choose Type"
                className="form-control w-100"
                options={filters}
                value={filters.find((item: object) =>
                  getValue(params, `type`, "")
                    ? getValue(params, `type`, "") ===
                      getValue(item, `value`, "")
                    : getValue(item, `value`, "") === "UPLOADED"
                )}
                onChange={(e: any) =>
                  handleNavigateFilter(getValue(e, `value`, ""))
                }
                label="Country"
                isClear
              />
            </div> */}
            <div></div>
            <div className="d-flex align-items-center gap">
              {/* <DatePicker
                onChange={setDate}
                value={date}
                format="MMM yyyy"
                disableCalendar={true}
                yearAriaLabel={'yyyy'}
              />
              <button className="header-apply-btn" onClick={handleSubmitDate}>
                Apply
              </button> */}
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
              />
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Audit
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Vendor Audit
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={false}
                //Line Seperator of button
                lineSeperator={true}
              />
            </div>
          </div>

          <div className={`main-page-layout-wrapper has-module-filter`} >
          <section className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex justify-content-between">
              <div className="filter-form-wrappper__location d-flex">
                <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper">
                  <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                    <label
                      htmlFor="country_id"
                      className="floating-label ms-0"
                    >
                      Account
                    </label>
                    
                    <FilterSearchDropdown
                      placeholder={"Search Account"}
                      options={filteredAccount}
                      searchLoading={searchLoading}
                      handleChange={(val: any) =>
                        handleTriggerAccount(val)
                      }
                      handleClick={(e: any) =>
                        handleChangeFilter("group_id", e.id)
                      }
                      value={
                        getValue(filteredAccount, `length`, 0) > 0 &&
                        filteredAccount.filter(
                          (item: object) =>
                            getValue(item, `id`, "") ==
                            getValue(pageFilter, `group`, "")
                        )[0]
                      }
                      label="label"
                      id="id"
                      name="Group"
                    />
                  </div>
                </div>

                <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper">
                <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Status
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT_MODAL"
                          placeholder="Choose Status"
                          className="form-control w-100"
                          options={complianceStatusList}
                          value={complianceStatusList.find(
                            (item: object) =>
                              getValue(params, `audit_status`, "") ===
                              getValue(item, `value`, "")
                          )}
                          onChange={(e: any) =>
                            handleNavigateFilter(getValue(e, `value`, ""))
                          }
                          label="Country"
                          isClear
                          customClass="module_filter_dropdown_wrapper"
                        />
                      </div>
                    </div>
              </div>
            </div>
          </section>

            <div className="admin-wrapper position-relative">
              <section className="uploaded-wrapper p-0 vendor-audit-page bg-white">
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : getValue(locations, `length`, 0) > 0 ? (
                  <>
                    <table className="uploaded-wrapper__table w-auto m-0 d-none">
                      <thead>
                        <tr>
                          <th style={{width:"100px", textAlign:"center"}}></th>
                          {/* <th style={{width:"60px"}}>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Cutoff-Date
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                                Start Date
                              </p>
                            </div>
                          </th> */}
                          <th style={{width:"150px"}}>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Vendor name
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                                Vendor Code
                              </p>
                            </div>
                          </th>
                          {/* <th>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Location Code
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                                Location Name
                              </p>
                            </div>
                          </th> */}
                          {/* <th style={{width:"60px"}}>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Vendor Code
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                            Not Uploaded
                          </p>
                            </div>
                          </th> */}
                          {/* <th>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Entity Name
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                                City Name
                              </p>
                            </div>
                          </th> */}
                          <th style={{width:"60px"}}>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Score
                              </h5>
                            </div>
                          </th>

                          <th style={{width:"150px"}}>
                            <div className="uploaded-wrapper__table-header-details">
                              <h5 className="uploaded-wrapper__table-header-title">
                                Total Audit
                              </h5>
                              <p className="uploaded-wrapper__table-header-text">
                                (Pending Audit / Still With Vendor / Audit Complete)
                              </p>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {locations.map((bodyObj: object, index: number) => {
                          return (
                            <tr
                              key={index}
                              onClick={() => handleNavigate(bodyObj)}
                            >
                              <td style={{width:"10%", textAlign:"center"}}>
                                <img
                                  src="/images/bubble.svg"
                                  className="img-fluid"
                                />
                              </td>
                              {/* <td style={{width:"60px"}}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--`}
                                  >
                                    {getValue(bodyObj, `cutoff_date`, "")
                                      ? convertCurrentDate(
                                          getValue(bodyObj, `cutoff_date`, "")
                                        )
                                      : ""}
                                  </h5>
                                  <p>
                                    {getValue(bodyObj, `start_date`, "")
                                      ? convertCurrentDate(
                                          getValue(bodyObj, `start_date`, "")
                                        )
                                      : ""}
                                  </p>
                                </div>
                              </td> */}
                              <td style={{width:"60px"}}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    {getValue(bodyObj, `vendor_name`, "")}
                                  </h5>
                                  <p>
                                    {" "}
                                    {formatText(
                                      getValue(bodyObj, `vendor_code`, "")
                                    )}
                                  </p>
                                </div>
                              </td>
                              {/* <td key={index}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    {getValue(bodyObj, `location_code`, '')}
                                  </h5>
                                  <p> {getValue(bodyObj, `location_name`, '')}</p>
                                </div>
                              </td> */}
                              {/* <td style={{width:"60px"}}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    {getValue(bodyObj, `vendor_code`, "")}
                                  </h5>
                                </div>
                              </td> */}
                              {/* <td>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    {getValue(bodyObj, `entity_name`, '')}
                                  </h5>
                                  <p>{getValue(bodyObj, `city_name`, '')}</p>
                                </div>
                              </td> */}

                              <td style={{width:"60px"}}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    {getValue(bodyObj, 'score', '') ? `${getValue(bodyObj, 'score', '')}%` : '- -'}
                                  </h5>
                                </div>
                              </td>

                              <td style={{width:"150px"}}>
                                <div className="uploaded-wrapper__table-body-details">
                                  <h5
                                    className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                                  >
                                    <span 
                                  //   className={`completed-tasks ${
                                  //   getValue(bodyObj, 'completed_task', '') === "0"
                                  //     ? 'full'  // Green when all tasks are completed
                                  //     : getValue(bodyObj, 'completed_task', '') ===
                                  //     getValue(bodyObj, 'total_checkpoints', '')
                                  //     ? 'zero'  // Red when all tasks are pending
                                  //     : ''
                                  // }`}
                                  >
                                    {getValue(bodyObj, `pending_audit`, '')} / {getValue(bodyObj, `still_with_vendor`, '')} / {getValue(bodyObj, `audit_complete_vendor`, '')} </span>
                                  </h5>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <ScrollableDataTable
                      columns={columns}
                      data={locations}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={true}
                      checkboxlogo
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}

                    />
                  </>
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <ManageAuditNotfound />
                    ) : (
                      <ManageAuditNotfound />
                    )}
                  </>
                )}
                {/* vendor-audit-footer */}
                <div className="">
                  <div className="footer-wrapper d-flex justify-content-between">
                    {/* {locations.length > 0 && ( */}
                    {/* <img
                      src="/images/profile-illustration.svg"
                      className="img-fluid"
                    /> */}
                    {/* )} */}
                    {totalCount > 10 ? (
                      <PaginationPage
                        totalCount={totalCount}
                        limit={limit}
                        pageNumber={page_no}
                        handleChangePagination={handleChangePagination}
                        handleChangeLimit={handleChangeLimit}
                      />
                    ) : (
                      <p className="show-rows-count mt-3 d-flex">
                        Total Count:&nbsp;&nbsp;{" "}
                        <p style={{ color: "rgb(13, 110, 253)" }}>
                          {totalCount}
                        </p>
                      </p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
